export default function getSubtotalAmount({
  productPriceAmount = 0,
  totalTicketTypesAmount = 0,
  quantity = 1,
  oneTimeVariantsAmount = 0,
  subscriptionVariantsAmount = 0,
  payWhatYouWantPrice = 0,
  productType = 'charge',
  planIterations = 0,
}) {
  if (totalTicketTypesAmount) {
    return totalTicketTypesAmount;
  }

  let price = productPriceAmount;

  if (productType === 'subscription') {
    if (planIterations > 0) {
      price = (price * quantity + subscriptionVariantsAmount) * planIterations;
    } else {
      price = price * quantity + subscriptionVariantsAmount;
    }

    price = price + oneTimeVariantsAmount;

    return price;
  } else {
    if (payWhatYouWantPrice) {
      price = payWhatYouWantPrice;
    }

    price = price * quantity + oneTimeVariantsAmount;

    return price;
  }
}
